/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personas_Scope_Team_RequiredInputs */



/**
* | output |
* | --- |
* | "Pick at least one team to share this persona with." |
*
* @param {Personas_Scope_Team_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const personas_scope_team_required = /** @type {((inputs?: Personas_Scope_Team_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personas_Scope_Team_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie mindestens ein Team, mit dem diese Persona geteilt wird.")
	return /** @type {LocalizedString} */ ("Pick at least one team to share this persona with.")
});